export const GET_RECORD_LABELS_URL = '/record-label';
export const SEARCH_RECORD_LABELS_URL = '/record-label/search';
export const CREATE_RECORD_LABEL_URL = '/record-label';
export const UPDATE_RECORD_LABEL_URL = (id) => `/record-label/${id}`;
export const INACTIVATE_RECORD_LABEL_URL = (id) => `/record-label/${id}/inactivate`;
export const ACTIVATE_RECORD_LABEL_URL = (id) => `/record-label/${id}/activate`;
export const DELETE_RECORD_LABEL_URL = (id) => `/record-label/${id}`;
export const GET_RECORD_LABEL_SONGS_URL = (id) => `/record-label/${id}/songs`;
export const GET_RECORD_LABEL_DETAILS_URL = (id) => `/record-label/${id}/details`;
export const EXPORT_RECORD_LABELS_URL = '/record-label/export';
